import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, filter, map } from 'rxjs/operators';
import { Actions } from '../../actions';
import { CreateTracLinkSuccess, ListTracLinks } from '../action-creators';
import AppState from '../../state';
import { SetActiveArtist } from '@webapp/store/artist/action-creators';
import { SET_ACTIVE_ARTIST } from '@webapp/store/artist/actions';
import { CREATE_TRAC_LINK_SUCCESS } from '../actions';

export const getArtistTracLinksEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, SetActiveArtist | CreateTracLinkSuccess>(
      SET_ACTIVE_ARTIST,
      CREATE_TRAC_LINK_SUCCESS
    ),
    withLatestFrom(state$),
    filter(([_, state]) => !!state.artist.active?.id),
    map(() => new ListTracLinks())
  );
